import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';

import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MaterialModule } from '../common-modules/material.module';
import { ConfirmationDialogModule } from '../components/confirmation-dialog/confirmation-dialog.module';
import { ChangeLogStatusPipe } from '../components/notification-details-popup/change-log-status/change-log-status.pipe';
import { NotificationDetailsPopupComponent } from '../components/notification-details-popup/notification-details-popup.component';
import { ContainerRefDirective } from '../shared/directives/container-ref.directive';
import { StickyElementDirective } from '../shared/directives/stickyElement/sticky-element.directive';
import { AppService } from './services/app.service';
import { AuthGuard } from './services/auth.guard';
import { NmdCalculationRoutingService } from './services/nmd-calculation-routing.service';
import { PrintDataResolver } from './services/print-data-resolver.service';
import { CustomToasterModule } from './services/toaster/toaster.module';
import { ToasterService } from './services/toaster/toaster.service';
import { SaveAsCalculationComponent } from '../components/save-as-calculation/save-as-calculation.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    SaveAsCalculationComponent,
    NotificationDetailsPopupComponent,
    StickyElementDirective,
    ChangeLogStatusPipe,
    ContainerRefDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    CustomToasterModule,
    MaterialModule,
    TranslateModule,
    ConfirmationDialogModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule.forRoot(),
    SharedModule
  ],
  providers: [
    ToasterService,
    AppService,
    AuthGuard,
    NmdCalculationRoutingService,
    PrintDataResolver
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    SaveAsCalculationComponent,
    CustomToasterModule
  ]
})
export class CoreModule {
}
